export default theme => ({
  root: {
    borderBottom: `2px solid #234563`,
    backgroundColor: theme.palette.common.white,
    display: "flex",
    alignItems: "center",
    height: "64px",
    // zIndex: theme.zIndex.appBar,
    zIndex: 1,
    direction: "rtl"
  },
  toolbar: {
    minHeight: "auto",
    width: "100%"
  },
  toolbarLtr: {
    minHeight: "auto",
    width: "100%",
    direction: "ltr"
  },
  title: {
    margin: theme.spacing(1)
  },
  menuButton: {
    margin: theme.spacing(1),
    color: "#e03c3c"
  },
  notificationsButton: {
    marginRight: "auto"
  },
  topBarlang: {
    marginLeft: "auto"
  },
  topBarlangfa: {
    marginRight: "auto"
  },
  signOutButton: {
    margin: theme.spacing(1),
    color: "#e03c3c"
  }
});
